/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Rekam_OkInputs */

const en_tut_rekam_ok = /** @type {(inputs: Tut_Rekam_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The indicator moves from **Rekaman berlangsung** through processing to **Siap**, and a recording card appears in the Rekaman tab.`)
};

const id_tut_rekam_ok = /** @type {(inputs: Tut_Rekam_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indikator berjalan dari **Rekaman berlangsung** ke **Memproses** lalu **Siap**, dan kartu rekaman muncul di tab Rekaman.`)
};

/**
* | output |
* | --- |
* | "The indicator moves from **Rekaman berlangsung** through processing to **Siap**, and a recording card appears in the Rekaman tab." |
*
* @param {Tut_Rekam_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_rekam_ok = /** @type {((inputs?: Tut_Rekam_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Rekam_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_rekam_ok(inputs)
	return en_tut_rekam_ok(inputs)
});